/**
 * @desc 根据id删除加油站信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
  /** 油站id */
  id?: number
}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolStation/del',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
